<app-loader></app-loader>
<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div *ngIf="!showInput" class="group-operator-view">

    <div class="grid custom-view">
        <div class="xl:col-1 lg:col-2">
            <div class="grid">
                <div class="md:col-12">
                    <div class="group-profile">
                        <img [src]="(driverDetails?.profileImagePath ? driverDetails?.profileImagePath: dummy)" alt="Profile"/>

                    </div>
                </div>
            </div>
        </div>
        <div class="md:col-11">
            <div class="grid">
                <div class="md:col-3">
                    <div class="group-field">
                        <p><strong>Company Name - </strong> <span>{{driverDetails?.companyName || driverDetails?.groupName}}</span></p>
                        <p><strong>DOT Number - </strong> <span>{{driverDetails?.dotNumber}}</span></p>
                    </div>
                    <div class="group-field">
                        <p><strong>Address - </strong> <span>{{driverDetails?.address}}</span></p>
                        <p><strong>Country - </strong> <span>{{driverDetails?.country}}</span></p>
                    </div>
                </div>
                <div class="md:col-3">
                    <div class="group-field">
                        <p><strong>First Name - </strong> <span>{{driverDetails?.firstName}}</span></p>
                        <p><strong>Last Name - </strong> <span>{{driverDetails?.lastName}}</span></p>
                    </div>
                    <div class="group-field">
                        <p><strong>City/Town - </strong> <span>{{driverDetails?.city}}</span></p>
                        <p><strong>Zipcode - </strong> <span>{{driverDetails?.zipCode}}</span></p>
                    </div>
                </div>
                <div class="md:col-4">
                    <div class="group-field">
                        <p><strong>Email - </strong> <span>{{driverDetails?.email}}</span></p>
                        <p class="phone-flag"><strong>Mobile Number - </strong> <span
                                *ngIf="!showInput && driverDetails?.mobileNumber" class="flag-outer"><img
                                    [ngClass]="getFlagClass(driverDetails?.iso)" alt=""/><span>{{driverDetails?.countryCode}}
                                    {{getFormattedMobileNumber()}}</span></span></p>
                    </div>
                    <div class="group-field">
                        <p><strong>Profile Created By - </strong> <span>{{driverDetails?.profileCreatedBy}}</span></p>
                        <p><strong>Profile Created On - </strong> <span>{{driverDetails?.profileCreated}}</span></p>
                    </div>
                </div>
                <div *ngIf="!showInput" class="col-12 md:col-2">
                    <div class="driver-info">
                        <div class="common-text credit-outer">
                            <p><strong>Credits</strong> <span class="custom-points">{{driverDetails?.credit}}
                                    Points</span><app-tooltip *ngIf='role === userRoles.SUPER_ADMIN'
                                    [tooltipMessage]="tooltipTableTemplate"
                                    [addClass]="'dues-tooltip-outer'"></app-tooltip></p>
                            <p><strong>Dues</strong> <span>${{driverDetails?.bookingDueCharges}}</span></p>

                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
    <div class="about-outer">
        <p><strong>About</strong> - {{driverDetails?.aboutGroup}}</p>
    </div>
</div>
<div *ngIf="showInput" class="group-oprator-edit">
    <form [formGroup]="driverUpdateForm">
        <div class="grid custom-view">
            <div class="xl:col-1 lg:col-2">
                <div class="grid">
                    <div class="md:col-12">
                        <div class="group-profile">
                            <img [src]="(imageUrl ? imageUrl : dummy)" alt=""/>
                            <div class="upload-outer">
                                <div *ngIf="showInput && !imageUrl">
                                    <img class="upload-img" id="profileImage"
                                        src="../../../../../assets/images/driver-edit.svg" alt="Profile"
                                        (click)="triggerFileInput()" />
                                    <input type="file" id="fileInput" style="display: none;"
                                        (change)="onImageSelected($event)">
                                </div>
                                <input type="file" id="fileInput1" style="display: none;"
                                    (change)="onImageSelected($event)">

                                <div *ngIf="showInput && imageUrl">
                                    <img class="upload-img" i src="../../../../../assets/images/circle-delete.svg"
                                        alt="Profile" (click)="clearImage()" />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="md:col-11">
                <div class="grid">
                    <div class="col">
                        <div class="company-input">
                            <label for="companyName">Company Name <span class="custom-star">*</span></label>
                            <input type="text" placeholder="Enter Company Name" pInputText formControlName="companyName"
                                maxlength="50" />
                            <div class="error-outer">
                                <div
                                    *ngIf="driverUpdateForm.get('companyName')?.hasError('minlength')  && (driverUpdateForm.get('companyName')?.dirty || driverUpdateForm.get('companyName')?.touched)">
                                    <div *ngIf="!driverUpdateForm.get('companyName')?.hasError('leadingSpace')"
                                        class="validation-error">Minimum 3 letters
                                        are required*</div>
                                </div>
                                <div
                                    *ngIf="driverUpdateForm.get('companyName')?.hasError('required')  && (driverUpdateForm.get('companyName')?.dirty || driverUpdateForm.get('companyName')?.touched)">
                                    <div class="validation-error">This field is required*</div>
                                </div>
                                <div *ngIf="driverUpdateForm.get('companyName').hasError('leadingSpace')"
                                    class="validation-error">
                                    Company name cannot start with a space.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="company-input">
                            <label for="dotNumber">DOT Number</label>
                            <input type="text" pInputText placeholder="Enter DOT Number" formControlName="dotNumber"
                                maxlength="12" />
                            <div *ngIf="driverUpdateForm.get('dotNumber').touched">
                                <div *ngIf="driverUpdateForm.get('dotNumber').hasError('pattern')">
                                    <div class="validation-error">Dot Number is invalid.</div>
                                </div>
                                <div
                                    *ngIf="driverUpdateForm.get('dotNumber').hasError('minlength') && !driverUpdateForm.get('dotNumber').hasError('pattern')">
                                    <div class="validation-error">Min. 6 digits are required.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="company-input">
                            <label for="firstName">First Name<span class="custom-star">*</span></label>
                            <input type="text" pInputText NoLeadingSpaceDirective placeholder="Enter First Name"
                                formControlName="firstName" maxlength="50" (keydown)="onKeyDown($event)" />
                            <div class="error-outer"
                                *ngIf="driverUpdateForm.get('firstName')?.dirty || driverUpdateForm.get('lastName')?.touched">
                                <div class="validation-error"
                                    *ngIf="driverUpdateForm.get('firstName')?.hasError('required')">
                                    This field is required*
                                </div>
                                <div class="validation-error"
                                    *ngIf="!driverUpdateForm.get('firstName')?.hasError('required') && driverUpdateForm.get('firstName')?.hasError('leadingSpace')">
                                    First Name cannot start with a space.*
                                </div>
                                <div class="validation-error"
                                    *ngIf="!driverUpdateForm.get('firstName')?.hasError('required') && !driverUpdateForm.get('firstName')?.hasError('leadingSpace') && driverUpdateForm.get('firstName')?.hasError('minlength')">
                                    Minimum 3 letters are required*
                                </div>
                                <div class="validation-error"
                                    *ngIf="!driverUpdateForm.get('firstName')?.hasError('required') && !driverUpdateForm.get('firstName')?.hasError('leadingSpace') && !driverUpdateForm.get('firstName')?.hasError('minlength') && driverUpdateForm.get('firstName')?.hasError('pattern')">
                                    Please enter only characters*
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="company-input">
                            <label for="lastName">Last Name
                                <span *ngIf="requiredLastNameAsterisk" class="custom-star">*</span>
                            </label>

                            <input type="text" pInputText placeholder="Enter Last Name" formControlName="lastName"
                                maxlength="50" (keydown)="onKeyDown($event)" />

                            <div class="error-outer"
                                *ngIf="driverUpdateForm.get('lastName')?.dirty || driverUpdateForm.get('lastName')?.touched">
                                <div class="validation-error"
                                    *ngIf="driverUpdateForm.get('lastName')?.hasError('required')">
                                    This field is required*
                                </div>
                                <div class="validation-error"
                                    *ngIf="!driverUpdateForm.get('lastName')?.hasError('required') && driverUpdateForm.get('lastName')?.hasError('leadingSpace')">
                                    Last Name cannot start with a space.*
                                </div>
                                <div class="validation-error"
                                    *ngIf="!driverUpdateForm.get('lastName')?.hasError('required') && !driverUpdateForm.get('lastName')?.hasError('leadingSpace') && driverUpdateForm.get('lastName')?.hasError('minlength')">
                                    Minimum 3 letters are required*
                                </div>
                                <div class="validation-error"
                                    *ngIf="!driverUpdateForm.get('lastName')?.hasError('required') && !driverUpdateForm.get('lastName')?.hasError('leadingSpace') && !driverUpdateForm.get('lastName')?.hasError('minlength') && driverUpdateForm.get('lastName')?.hasError('pattern')">
                                    Please enter only characters*
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="col">
                        <div class="company-input ">
                            <label for="email">Email<span class="custom-star">*</span></label>
                            <input type="text" pInputText placeholder="Enter Email" formControlName="email"
                                maxlength="50" />
                            <div class="error-outer">
                                 <div
                                    *ngIf="driverUpdateForm.get('email')?.hasError('required')  && (driverUpdateForm.get('email')?.dirty || driverUpdateForm.get('email')?.touched)">
                                    <div class="validation-error">This field is required*</div>
                                </div>
                                <div
                                    *ngIf="driverUpdateForm.get('email').hasError('pattern') && driverUpdateForm.get('email').touched && driverUpdateForm.get('email').invalid">
                                    <small class="validation-error">Email is not
                                        valid*</small>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid custom-margin">
                    <div class="col">
                        <div class="company-input country-code">
                            <label for="phone">Mobile Number<span class="custom-star">*</span></label>

                            <ngx-intl-tel-input [cssClass]="'custom'"
                                [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                                [enablePlaceholder]="true" [searchCountryFlag]="true"
                                [searchCountryField]="[searchCountryField.Iso2, searchCountryField.Name]"
                                [selectFirstCountry]="false" [selectedCountryISO]="countryISO"
                                customPlaceholder="Enter Mobile Number" [maxLength]="10" [phoneValidation]="true"
                                [separateDialCode]="separateDialCode" [numberFormat]="phoneNumberFormat.National"
                                name="phone" formControlName="phone" >
                            </ngx-intl-tel-input>

                            <div class="error-outer">
                                <div
                  *ngIf="driverUpdateForm.get('phone')?.hasError('required') && driverUpdateForm.get('phone')?.dirty && driverUpdateForm.get('phone')?.touched">
                  <small class="validation-error">This field is required*</small>
                </div>
                <div
                  *ngIf="!driverUpdateForm.get('phone')?.hasError('required') && driverUpdateForm.get('phone')?.touched && driverUpdateForm.get('phone')?.invalid">
                  <small class="validation-error">Mobile number is not valid*</small>
                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="company-input">
                            <label for="address">Address</label>
                            <input id="address" type="text" placeholder="Enter Address" pInputText formControlName="address"
                                maxlength="100" />

                            <div class="error-outer">
                                <div
                                    *ngIf="driverUpdateForm.get('address')?.hasError('required')  && (driverUpdateForm.get('address')?.dirty || driverUpdateForm.get('address')?.touched)">
                                    <div class="validation-error"> This field is required*</div>
                                </div>
                                <div
                                    *ngIf="driverUpdateForm.get('address')?.hasError('pattern')  && (driverUpdateForm.get('address')?.dirty || driverUpdateForm.get('address')?.touched)">
                                    <div class="validation-error"> Please enter only characters*</div>
                                </div>
                                <div *ngIf="driverUpdateForm.get('address').hasError('leadingSpace')"
                                    class="validation-error">
                                    Address cannot start with a space.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="company-input">
                            <label for="country">Country</label>
                            <input id="country" type="text" placeholder="Enter Country" pInputText formControlName="country"
                                maxlength="50" (keydown)="onKeyDown($event)" />

                            <div class="error-outer">
                                <div
                                    *ngIf="driverUpdateForm.get('country')?.hasError('minlength')  && (driverUpdateForm.get('country')?.dirty || driverUpdateForm.get('country')?.touched)">
                                    <div *ngIf="!driverUpdateForm.get('country').hasError('leadingSpace')"
                                        class="validation-error">Minimum 3 letters
                                        are required*</div>
                                </div>
                                <div
                                    *ngIf="driverUpdateForm.get('country')?.hasError('required')  && (driverUpdateForm.get('country')?.dirty || driverUpdateForm.get('country')?.touched)">
                                    <div class="validation-error"> This field is required*</div>
                                </div>
                                <div *ngIf="driverUpdateForm.get('country').hasError('leadingSpace')"
                                    class="validation-error">
                                    Country name cannot start with a space.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col">
                        <div class="company-input">
                            <label for="city">City/Town</label>
                            <input id="city" type="text" placeholder="Enter City/Town" pInputText formControlName="city"
                                maxlength="50" (keydown)="onKeyDown($event)" />
                            <div class=" error-outer">
                                <ng-container
                                    *ngIf="driverUpdateForm.get('city')?.dirty || driverUpdateForm.get('city')?.touched">
                                    <div *ngIf="driverUpdateForm.get('city')?.hasError('required')">
                                        <div class="validation-error">This field is required*</div>
                                    </div>
                                    <div *ngIf="driverUpdateForm.get('city')?.hasError('pattern')">
                                        <div class="validation-error">Please enter only digits*
                                        </div>
                                    </div>
                                    <div *ngIf="driverUpdateForm.get('city')?.hasError('minlength')">
                                        <div *ngIf="!driverUpdateForm.get('city').hasError('leadingSpace')"
                                            class="validation-error"> Minimum 3 characters are
                                            required*</div>
                                    </div>
                                    <div *ngIf="driverUpdateForm.get('city').hasError('leadingSpace')"
                                        class="validation-error">
                                        City name cannot start with a space.
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="company-input">
                            <label for="zipcode">Zip Code</label>
                            <input id="zipcode" type="text" placeholder="Enter Zip Code" pInputText formControlName="zipCode"
                                maxlength="20" />
                            <ng-container
                                *ngIf="driverUpdateForm.get('zipCode')?.dirty || driverUpdateForm.get('zipCode')?.touched">
                                <div *ngIf="driverUpdateForm.get('zipCode')?.hasError('required')">
                                    <div class="validation-error">This field is required*</div>
                                </div>
                                <div *ngIf="driverUpdateForm.get('zipCode')?.hasError('pattern')">
                                    <div class="validation-error">Please enter only digits*
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="grid custom-margin">
                    <div class="col-12">
                        <div class="company-input">
                            <label for="aboutGroup">About the business</label>
                            <textarea placeholder="Enter about the business
                            " pInputTextarea formControlName="aboutGroup">
                    </textarea>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="save-outer custom-tabs">
                            <span class="secorday-outer">
                                <p-button class="secondary-btn custom-secondary mr-3" styleClass="search-button"
                                    (onClick)="calcelDriverInfoEdit(driverDetails)" label="Cancel"></p-button></span>
                            <p-button styleClass="p-button search-button" (onClick)="updateDriverInformation()"
                                label="Save Changes" type="submit"></p-button>

</div>
                    </div>
                </div>

            </div>

        </div>
    </form>
</div>

<ng-template #tooltipTableTemplate>
  <div class="dues-table">
    <!-- Check if userCredits exist -->
    <ng-container *ngIf="driverDetails?.userCredits?.length > 0; else noCredits">

      <!-- Check if there are any valid credits -->
      <ng-container *ngIf="hasValidCredits(); else noCredits">
        <div class="dues-heading">
          <h5>Company Name</h5>
          <h5>Credits</h5>
        </div>

        <!-- List each credit with amount > 0 -->
        <div *ngFor="let credit of driverDetails.userCredits">
          <ng-container *ngIf="credit.amount > 0">
            <div class="table-body">
              <p>{{ credit.companyName }}</p>
              <p>{{ credit.amount }}</p>
            </div>
          </ng-container>
        </div>
      </ng-container>

    </ng-container>

    <ng-template #noCredits>
      <div class="table-body"><p>No credits yet</p></div>
    </ng-template>
  </div>
</ng-template>
